import { createStyles, CSSObject } from "@mantine/core";

export const useStyles = createStyles(() => ({
  collectorAssignedWrapper: {
    wordWrap: "break-all" as CSSObject["wordWrap"],
    overflowWrap: "anywhere",
  },
}));
